/**
 * Created by zhangrp on 2018/4/11.
 */
import api from './index'

let exports = {};
//

//请购单管理
exports.getDeviceRequireVoucherCountMapByFilter = function (callback) {
    api.post('/devcReqr/device/require/voucher/home/count/get')
    .done(callback)
    .fail(callback)
    .go();
};

//询盘管理
exports.getDealInqryVoucherCountMapByFilter = function (callback) {
    api.post('/deal/inqry/voucher/home/count/get')
    .done(callback)
    .fail(callback)
    .go();
};

//询价管理
exports.getPriceInqryVoucherCountMapByFilter = function (callback) {
    api.post('/price/inqry/voucher/home/count/get')
    .done(callback)
    .fail(callback)
    .go();
};

//供方发货协同
exports.getGoodsShipVoucherCountMapByFilter = function (callback) {
    api.post('/goodsDeliv/ship/voucher/home/count/get')
    .done(callback)
    .fail(callback)
    .go();
};

// 待付款数量
exports.getPayVoucherCountMapByFilter = function (callback) {
    api.post('/finac/pay/voucher/home/count/get')
    .done(callback)
    .fail(callback)
    .go();
};

//服务商付款
exports.getServicerPayVoucherCountMapByFilter = function (callback) {
    api.post('/finac/servicer/pay/voucher/home/count/get')
    .done(callback)
    .fail(callback)
    .go();
};

//服务商退款
exports.getServicerRefundVoucherCountMapByFilter = function (callback) {
    api.post('/finac/servicer/refund/voucher/home/count/get')
    .done(callback)
    .fail(callback)
    .go();
};

//供应商退款
exports.getVendorRefundVoucherCountMapByFilter = function (callback) {
    api.post('/finac/vendor/refund/voucher/home/count/get')
    .done(callback)
    .fail(callback)
    .go();
};

//发票管理
exports.getInvoiceVoucherCountMapByFilter = function (callback) {
    api.post('/finac/invoive/voucher/home/count/get')
    .done(callback)
    .fail(callback)
    .go();
};

//招标管理
exports.getCallBidDocCountMapByFilter = function (callback) {
    api.post('/callBid/doc/home/count/get')
    .done(callback)
    .fail(callback)
    .go();
};

//设备采购合同管理 | 服务采购合同管理 | 集成采购合同管理
exports.getContractCountMapByFilter = function (params, callback) {
    api.post('/contract/home/count/get')
    .data(params)
    .done(callback)
    .fail(callback)
    .go();
};




export default exports;



//////////////////
// WEBPACK FOOTER
// ./src/api/workBench.js
// module id = 1765
// module chunks = 0